import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { AuthFacade, SharedFacade, UserDetailsFacade } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { Router } from '@angular/router';
import { UserDetailsService } from 'libs/data/src/lib/services/user-details/user-details.service';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { VersionDetectService } from 'libs/shared/src/lib/service/AppUpdateServices/version-detect.service';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'libs/data/src/lib/services/auth/authentication.service';
import { CommonService } from 'libs/shared/src/lib/service/common.service';
import { SessionService } from 'libs/shared/src/lib/service/session.service';
@Component({
  selector: 'piqet-angular-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  orgName: any;
  orgData: any;
  selectedOrg: any;
  userDetailsService = inject(UserDetailsService);
  public showUpdateNotification = false;
  private subscription: Subscription = new Subscription();

  deviceId: any;
  private bc = new BroadcastChannel('session_channel');
  private tabId: string = Math.random().toString(36).substring(2, 15);
  constructor(
    private authFacade: AuthFacade,
    public sharedFacade: SharedFacade,
    public UserDetailsFacade: UserDetailsFacade,
    private modal: CustomModalService,
    public sharedService: SharedService,
    private versionDetectService: VersionDetectService,
    private toastService: ToastrService,
    private router: Router,
    private cookieService: CookieService,
    private authenticationService: AuthenticationService,
    private commonService: CommonService,
    private sessionService: SessionService
  ) {
    this.deviceId = this.commonService.initDeviceId();
  }

  ngOnInit(): void {
    this.UserDetailsFacade.getOrganizationList();
    this.subscription.add(
      this.versionDetectService.showUpdateNotification$.subscribe((show: boolean) => {
        this.showUpdateNotification = show;
      })
    );
  }

  async logout() {
    await this.authenticationService
      .logout(this.cookieService.get('userId'), this.commonService.initDeviceId())
      .subscribe((res: any) => {
        this.authFacade.logout();
        this.sessionService.logout();
      });
  }

  applyUpdate(): void {
    this.versionDetectService.applyUpdate();
  }

  openSelectOrganizationModel(organizationList: any | unknown[]) {
    this.modal.invoke('selectOrganization', {
      initialState: {
        organizationList: organizationList,
        onSuccess: () => {},
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.changeOrganization.subscribe((data: any) => {
      this.UserDetailsFacade.changeOrganization(data);
      this.toastService.success('Organization changed successfully.');
      // delayedFunctionCall(this.getOrgData, 100, this)
    });
  }

  openTour() {
    this.router.navigate(['/dashboard'], { queryParams: { haveTour: true } });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.versionDetectService.hideUpdateNotification();
  }
}
